var map = {
	"./Admin/Admins/Create": [
		52860,
		5394,
		2860
	],
	"./Admin/Admins/Create.jsx": [
		52860,
		5394,
		2860
	],
	"./Admin/Admins/List": [
		51348,
		1348
	],
	"./Admin/Admins/List.jsx": [
		51348,
		1348
	],
	"./Admin/CustomerRequests/List": [
		53398,
		2637,
		3398
	],
	"./Admin/CustomerRequests/List.jsx": [
		53398,
		2637,
		3398
	],
	"./Admin/CustomerRequests/View": [
		94517,
		2637,
		4517
	],
	"./Admin/CustomerRequests/View.jsx": [
		94517,
		2637,
		4517
	],
	"./Admin/Customers/Create": [
		42393,
		5394,
		2393
	],
	"./Admin/Customers/Create.jsx": [
		42393,
		5394,
		2393
	],
	"./Admin/Customers/List": [
		67365,
		5394,
		7365
	],
	"./Admin/Customers/List.jsx": [
		67365,
		5394,
		7365
	],
	"./Admin/Dashboard": [
		13174,
		5299,
		3174
	],
	"./Admin/Dashboard/": [
		13174,
		5299,
		3174
	],
	"./Admin/Dashboard/LoginHistory": [
		9381,
		9381
	],
	"./Admin/Dashboard/LoginHistory.jsx": [
		9381,
		9381
	],
	"./Admin/Dashboard/Profile": [
		81089,
		5394,
		1089
	],
	"./Admin/Dashboard/Profile.jsx": [
		81089,
		5394,
		1089
	],
	"./Admin/Dashboard/Setting": [
		23068,
		3068
	],
	"./Admin/Dashboard/Setting.jsx": [
		23068,
		3068
	],
	"./Admin/Dashboard/index": [
		13174,
		5299,
		3174
	],
	"./Admin/Dashboard/index.jsx": [
		13174,
		5299,
		3174
	],
	"./Admin/FestivalOffers/Create": [
		52279,
		2279
	],
	"./Admin/FestivalOffers/Create.jsx": [
		52279,
		2279
	],
	"./Admin/FestivalOffers/List": [
		5727,
		5727
	],
	"./Admin/FestivalOffers/List.jsx": [
		5727,
		5727
	],
	"./Admin/MachineDemo/Create": [
		54478,
		4478
	],
	"./Admin/MachineDemo/Create.jsx": [
		54478,
		4478
	],
	"./Admin/MachineDemo/List": [
		15410,
		5410
	],
	"./Admin/MachineDemo/List.jsx": [
		15410,
		5410
	],
	"./Admin/MachineTypes/Create": [
		58302,
		8302
	],
	"./Admin/MachineTypes/Create.jsx": [
		58302,
		8302
	],
	"./Admin/MachineTypes/List": [
		92034,
		2034
	],
	"./Admin/MachineTypes/List.jsx": [
		92034,
		2034
	],
	"./Admin/Machines/Create": [
		5670,
		5670
	],
	"./Admin/Machines/Create.jsx": [
		5670,
		5670
	],
	"./Admin/Machines/List": [
		87370,
		7370
	],
	"./Admin/Machines/List.jsx": [
		87370,
		7370
	],
	"./Admin/OrderProgress/List": [
		61875,
		1875
	],
	"./Admin/OrderProgress/List.jsx": [
		61875,
		1875
	],
	"./Admin/OrderRequests/List": [
		6446,
		6446
	],
	"./Admin/OrderRequests/List.jsx": [
		6446,
		6446
	],
	"./Admin/Orders/Create": [
		24193,
		7443,
		4193
	],
	"./Admin/Orders/Create.jsx": [
		24193,
		7443,
		4193
	],
	"./Admin/Orders/List": [
		50285,
		7443,
		285
	],
	"./Admin/Orders/List.jsx": [
		50285,
		7443,
		285
	],
	"./Admin/Orders/View": [
		8478,
		7443,
		8478
	],
	"./Admin/Orders/View.jsx": [
		8478,
		7443,
		8478
	],
	"./Admin/Roles/Create": [
		12217,
		5394,
		2217
	],
	"./Admin/Roles/Create.jsx": [
		12217,
		5394,
		2217
	],
	"./Admin/Roles/List": [
		26981,
		5394,
		6981
	],
	"./Admin/Roles/List.jsx": [
		26981,
		5394,
		6981
	],
	"./Admin/ServiceInspection/Create": [
		32733,
		2733
	],
	"./Admin/ServiceInspection/Create.jsx": [
		32733,
		2733
	],
	"./Admin/ServiceInspection/List": [
		66289,
		6289
	],
	"./Admin/ServiceInspection/List.jsx": [
		66289,
		6289
	],
	"./Admin/ServiceStaffs/Create": [
		35072,
		5394,
		5072
	],
	"./Admin/ServiceStaffs/Create.jsx": [
		35072,
		5394,
		5072
	],
	"./Admin/ServiceStaffs/List": [
		68864,
		5394,
		8864
	],
	"./Admin/ServiceStaffs/List.jsx": [
		68864,
		5394,
		8864
	],
	"./Admin/Stores/Create": [
		55150,
		5394,
		5150
	],
	"./Admin/Stores/Create.jsx": [
		55150,
		5394,
		5150
	],
	"./Admin/Stores/List": [
		39506,
		5394,
		9506
	],
	"./Admin/Stores/List.jsx": [
		39506,
		5394,
		9506
	],
	"./Admin/Terms/Create": [
		41095,
		1095
	],
	"./Admin/Terms/Create.jsx": [
		41095,
		1095
	],
	"./Admin/Terms/List": [
		51887,
		1887
	],
	"./Admin/Terms/List.jsx": [
		51887,
		1887
	],
	"./Admin/Users/Create": [
		66016,
		5394,
		6016
	],
	"./Admin/Users/Create.jsx": [
		66016,
		5394,
		6016
	],
	"./Admin/Users/List": [
		45440,
		5394,
		5440
	],
	"./Admin/Users/List.jsx": [
		45440,
		5394,
		5440
	],
	"./Admin/Wallets/List": [
		89530,
		9530
	],
	"./Admin/Wallets/List.jsx": [
		89530,
		9530
	],
	"./Admin/WarrantyServices/List": [
		93172,
		8954,
		3172
	],
	"./Admin/WarrantyServices/List.jsx": [
		93172,
		8954,
		3172
	],
	"./Admin/WarrantyServices/View": [
		94295,
		8954,
		4295
	],
	"./Admin/WarrantyServices/View.jsx": [
		94295,
		8954,
		4295
	],
	"./Admin/WithdrawalRequests/List": [
		48037,
		8037
	],
	"./Admin/WithdrawalRequests/List.jsx": [
		48037,
		8037
	],
	"./Admin/WithdrawalRequests/View": [
		64230,
		4230
	],
	"./Admin/WithdrawalRequests/View.jsx": [
		64230,
		4230
	],
	"./Auth/ForgotPassword": [
		2716,
		2716
	],
	"./Auth/ForgotPassword.jsx": [
		2716,
		2716
	],
	"./Auth/Login": [
		95283,
		5283
	],
	"./Auth/Login.jsx": [
		95283,
		5283
	],
	"./Auth/ResetPassword": [
		71354,
		1354
	],
	"./Auth/ResetPassword.jsx": [
		71354,
		1354
	],
	"./Auth/VerifyEmail": [
		88925,
		8925
	],
	"./Auth/VerifyEmail.jsx": [
		88925,
		8925
	],
	"./Error": [
		76053,
		6053
	],
	"./Error.jsx": [
		76053,
		6053
	],
	"./PrivacyPolicy": [
		44797,
		4797
	],
	"./PrivacyPolicy.jsx": [
		44797,
		4797
	],
	"./User/CustomerRequests/List": [
		73314,
		2637,
		3314
	],
	"./User/CustomerRequests/List.jsx": [
		73314,
		2637,
		3314
	],
	"./User/CustomerRequests/View": [
		20937,
		2637,
		937
	],
	"./User/CustomerRequests/View.jsx": [
		20937,
		2637,
		937
	],
	"./User/Customers/Create": [
		65573,
		5394,
		5573
	],
	"./User/Customers/Create.jsx": [
		65573,
		5394,
		5573
	],
	"./User/Customers/List": [
		91993,
		5394,
		1993
	],
	"./User/Customers/List.jsx": [
		91993,
		5394,
		1993
	],
	"./User/Dashboard": [
		31978,
		5299,
		1978
	],
	"./User/Dashboard/": [
		31978,
		5299,
		1978
	],
	"./User/Dashboard/Profile": [
		64717,
		5394,
		4717
	],
	"./User/Dashboard/Profile.jsx": [
		64717,
		5394,
		4717
	],
	"./User/Dashboard/index": [
		31978,
		5299,
		1978
	],
	"./User/Dashboard/index.jsx": [
		31978,
		5299,
		1978
	],
	"./User/FestivalOffers/Create": [
		21867,
		1867
	],
	"./User/FestivalOffers/Create.jsx": [
		21867,
		1867
	],
	"./User/FestivalOffers/List": [
		64155,
		4155
	],
	"./User/FestivalOffers/List.jsx": [
		64155,
		4155
	],
	"./User/MachineDemo/Create": [
		79818,
		9818
	],
	"./User/MachineDemo/Create.jsx": [
		79818,
		9818
	],
	"./User/MachineDemo/List": [
		53350,
		3350
	],
	"./User/MachineDemo/List.jsx": [
		53350,
		3350
	],
	"./User/MachineTypes/Create": [
		29938,
		9938
	],
	"./User/MachineTypes/Create.jsx": [
		29938,
		9938
	],
	"./User/MachineTypes/List": [
		80942,
		942
	],
	"./User/MachineTypes/List.jsx": [
		80942,
		942
	],
	"./User/Machines/Create": [
		91578,
		1578
	],
	"./User/Machines/Create.jsx": [
		91578,
		1578
	],
	"./User/Machines/List": [
		92822,
		2822
	],
	"./User/Machines/List.jsx": [
		92822,
		2822
	],
	"./User/OrderProgress/List": [
		49711,
		9711
	],
	"./User/OrderProgress/List.jsx": [
		49711,
		9711
	],
	"./User/OrderRequests/List": [
		52914,
		2914
	],
	"./User/OrderRequests/List.jsx": [
		52914,
		2914
	],
	"./User/Orders/Create": [
		76821,
		7443,
		6821
	],
	"./User/Orders/Create.jsx": [
		76821,
		7443,
		6821
	],
	"./User/Orders/List": [
		56073,
		7443,
		6073
	],
	"./User/Orders/List.jsx": [
		56073,
		7443,
		6073
	],
	"./User/Orders/View": [
		49634,
		7443,
		9634
	],
	"./User/Orders/View.jsx": [
		49634,
		7443,
		9634
	],
	"./User/Roles/Create": [
		69253,
		5394,
		9253
	],
	"./User/Roles/Create.jsx": [
		69253,
		5394,
		9253
	],
	"./User/Roles/List": [
		61817,
		5394,
		1817
	],
	"./User/Roles/List.jsx": [
		61817,
		5394,
		1817
	],
	"./User/ServiceInspection/Create": [
		74529,
		4529
	],
	"./User/ServiceInspection/Create.jsx": [
		74529,
		4529
	],
	"./User/ServiceInspection/List": [
		29549,
		9549
	],
	"./User/ServiceInspection/List.jsx": [
		29549,
		9549
	],
	"./User/ServiceStaffs/Create": [
		50836,
		5394,
		836
	],
	"./User/ServiceStaffs/Create.jsx": [
		50836,
		5394,
		836
	],
	"./User/ServiceStaffs/List": [
		26380,
		5394,
		6380
	],
	"./User/ServiceStaffs/List.jsx": [
		26380,
		5394,
		6380
	],
	"./User/Stores/Create": [
		41250,
		5394,
		1250
	],
	"./User/Stores/Create.jsx": [
		41250,
		5394,
		1250
	],
	"./User/Stores/List": [
		73278,
		5394,
		3278
	],
	"./User/Stores/List.jsx": [
		73278,
		5394,
		3278
	],
	"./User/Terms/Create": [
		16451,
		6451
	],
	"./User/Terms/Create.jsx": [
		16451,
		6451
	],
	"./User/Terms/List": [
		31827,
		1827
	],
	"./User/Terms/List.jsx": [
		31827,
		1827
	],
	"./User/Users/Create": [
		20564,
		5394,
		564
	],
	"./User/Users/Create.jsx": [
		20564,
		5394,
		564
	],
	"./User/Users/List": [
		52044,
		5394,
		2044
	],
	"./User/Users/List.jsx": [
		52044,
		5394,
		2044
	],
	"./User/Wallets/List": [
		53774,
		3774
	],
	"./User/Wallets/List.jsx": [
		53774,
		3774
	],
	"./User/WarrantyServices/List": [
		63608,
		8954,
		3608
	],
	"./User/WarrantyServices/List.jsx": [
		63608,
		8954,
		3608
	],
	"./User/WarrantyServices/View": [
		7075,
		8954,
		7075
	],
	"./User/WarrantyServices/View.jsx": [
		7075,
		8954,
		7075
	],
	"./User/WithdrawalRequests/List": [
		79185,
		9185
	],
	"./User/WithdrawalRequests/List.jsx": [
		79185,
		9185
	],
	"./User/WithdrawalRequests/View": [
		94490,
		4490
	],
	"./User/WithdrawalRequests/View.jsx": [
		94490,
		4490
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 35427;
module.exports = webpackAsyncContext;